//implementacion de ngxdatatable
//https://stackoverflow.com/questions/51303630/how-to-use-edit-and-delete-options-in-angular-ngx-datatables

//solucion para usar metodos de angular en html
//https://stackblitz.com/edit/angular-c6vfcq?file=src%2Fapp%2Fapp.component.html

//solución al asignar el input date 
//https://stackblitz.com/edit/angular-xuvrtq?file=src%2Fapp%2Fapp.component.ts

import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { DatatableComponent } from '@swimlane/ngx-datatable';
import { EmptyError } from 'rxjs';
import { UsuarioService } from '../../services/usuario.service';
import { Respuesta } from '../../models/respuesta';
import { RespuestaService } from '../../services/respuesta.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { GLOBAL } from '../../services/global';
import { UploadService } from '../../services/upload.service';

declare var $:any;

@Component({
    selector:'admin-respuesta',
    templateUrl:'./admin-respuesta.component.html',
    providers:[UsuarioService,RespuestaService,UploadService],
    //styleUrls:['../']
})

export class AdminRespuestaComponent implements OnInit{
    @ViewChild('addForm') formValues:NgForm; //added this
    public title:string;
    public respuesta:Respuesta;
    public status:string;
    public errorTexto:string;
    fromDate;

    public token;

    editing = {};
    rows = [];
    columns = [];
    selected=[];
    temp = [];

    public url: string;

    loadingIndicator:boolean = true;
    reaorderable: boolean = true;

    @ViewChild(DatatableComponent) table: DatatableComponent;

    constructor(
        private _usuarioService: UsuarioService,
        private _respuestaService: RespuestaService,
        private _uploadService:UploadService
    ){
        this.title = 'Catálogo de respuestas';
        this.url = GLOBAL.url;
        this.token = this._usuarioService.getToken();
        this.inicializarClase();
        this.GRIDlistar();
}

/**
 * Métodos
 */

 inicializarClase(){
    this.respuesta = new Respuesta(0,"",1,"",true,new Date(),true,new Date(),new Date(),"");
    return this.respuesta;
 }

ngOnInit(){
    console.log('Componente admin respuesta cargado');
    this.token = this._usuarioService.getToken();

    this.columns = [
        { Name:'ID',prop: 'ID'},
        { name:'DESCRIPCIÓN', prop: 'DESCRIPCION'},
        { name:'VALOR', prop: 'VALOR'},
        { name:'ES POSITIVO', prop: 'bandera_texto'},
        { name:'ESTATUS', prop:'estatus_texto'}
    ]
}

btn_nuevo(){
    this.inicializarClase();
    $("#fileRespuesta").val('');
    $('#exampleModal').modal('show');
}

GRIDlistar(){
    this._respuestaService.GRIDlistar(this.token).subscribe(
        response =>{
            this.rows = response.items;
            this.temp = response.items;
            console.log("LOG DE RECARGAR GRID: " + JSON.stringify(this.rows));
        },
        err =>{
            var errorMessage = <any>err;
            console.log('respuesta del servidor (error): ' + JSON.stringify(errorMessage.error.message));
            this.errorTexto = errorMessage.error.message;
            if(errorMessage !=null){
                this.status = 'error';
            }
        }
    );
}

    /*onSelect({ selected }) {
        console.log('Select Event', selected, this.selected);
      }*/
    
    onActivate(event) {
    if(event.type == 'click') {
        this.status = "";
        this.respuesta = event.row;
        $("#fileRespuesta").val('');
        $('#exampleModal').modal('show');
    }
}

onSubmit(){
    console.log("LOG DE GUARDAR RESPUESTA: " + JSON.stringify(this.respuesta));
    this._respuestaService.gestion(this.respuesta,this.token).subscribe(
        response =>{

            var idRespuesta;
            //this.empresa = response.newEmpresa;
            if(this.respuesta.ID ==0){
                idRespuesta = response.item.ID;
            }
            else{
                idRespuesta = this.respuesta.ID;
            }

            //SUBIDA DE IMAGEN DE EMPRESA
            this._uploadService.makeFileRequest(this.url+'respuesta-subir-imagen/'+idRespuesta,[],this.filesToUpload,this.token,'image')
                .then((result:any)=>{
                    console.log('resultados del makefilerequest' + result);
                    this.respuesta.IMAGEN = result.item.IMAGEN;
                    this.GRIDlistar();
                })

            $('#txtBuscar').val('');
            //this.GRIDlistar();
            this.formValues.resetForm(); // Added this
            this.status = "";
            $('#exampleModal').modal('hide');
        },
        err =>{
            var errorMessage = <any>err;
            console.log('respuesta del servidor (error): ' + JSON.stringify(errorMessage.error.message));
            this.errorTexto = errorMessage.error.message;
            if(errorMessage !=null){
                this.status = 'error';
            }
        }
    );
}

public filesToUpload: Array<File>;
fileChangedEvent(fileInput:any){
    this.filesToUpload = <Array<File>>fileInput.target.files;
    console.log('log de filestoupload: ' + this.filesToUpload);
}

updateFilter(event) {
    const val = event.target.value.toLowerCase();   
    // filter our data
    const temp = this.temp.filter(function(d) {
        return d.DESCRIPCION.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
}
}